import React, { FC, useCallback, useState } from 'react'
import { styled, Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Grid, Switch, Typography } from '@mui/material'
import { SwitchProps } from '@mui/material/Switch'
import { useFormContext } from 'react-hook-form'

interface IProps {
  disabled?: boolean
  label: string
}
const useStyle = makeStyles((theme: Theme) => ({
  main: {
    width: 272,
    marginTop: 24,
  },
  switch: {
    opacity: ({ disabled }: IProps) => (disabled ? 0.6 : 1),
  },
  label: {
    opacity: 0.8,
    color: theme.palette.primary.light,
  },
}))

const AntSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 40,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 3,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.secondary.main,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18,
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    backgroundColor: '#A4A7AA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

export const InputSwitch: FC<IProps> = ({ disabled, label }) => {
  const classes = useStyle({ disabled, label })
  const [checked, setChecked] = useState<boolean>(false)

  const { setValue } = useFormContext()

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setChecked(event.target.checked)
      setValue('twoFaEnabled', event.target.checked)
    },
    [setValue],
  )

  return (
    <Grid className={classes.main} container direction={'row'} justifyContent={'space-between'}>
      <Grid item>
        <Typography className={classes.label}>{label}</Typography>
      </Grid>
      <Grid item>
        <AntSwitch
          className={classes.switch}
          disabled={disabled}
          checked={checked}
          onChange={handleChange}
          color="secondary"
          name="twoFaEnabled"
        />
      </Grid>
    </Grid>
  )
}
